import { envConfig } from '@peerup/host-env'
import { runOnceBeforeFinallySameArgs } from '@peerup/utils'

export const EMPTY_CHART = '\uFFFD'
export const EMPTY_SVG = '<!-- svg 加载失败 -->\uFFFD'

export const contentCache = new Map<string, string>() // 缓存图标内容
/**
 * 获取图标地址
 * @param name 图标名称
 * @returns 图标地址
 */
export const getIconMap = (name: string) => {
  return `${envConfig.STATIC_URL}/assets/img/${name}.svg`
}

export const getIconMapWithPrivateBrandLogo = (name: string) => {
  return `${envConfig.STATIC_URL}/assets/img/${name}${envConfig.PRIVATE_BRAND_LOGO}.svg`
}

/**
 * 获取图标内容
 * @param iconUrl 图标地址
 * @returns 图标内容
 */
export const fetchIconContent = runOnceBeforeFinallySameArgs(async (iconUrl: string) => {
  if (contentCache.has(iconUrl)) {
    return contentCache.get(iconUrl)!
  }
  const response = await fetch(iconUrl)
  let text = await response.text()
  if (text.startsWith('<svg') || (text.startsWith('<?xml') && !text.includes('<Error>'))) {
    text = text.replace(/<svg/g, '<svg class="svg-icon"')
  } else {
    throw new Error(text)
  }
  contentCache.set(iconUrl, text)
  return text
})

// ── sprite 懒加载 ────────────────────────────────────────────────
// 仅动态引用 sprite 模块（811 个图标字符串聚合为单个懒 chunk，不进入口闭包）。
// 本模块随组件极早执行，import('./sprite') 在此发起 = chunk 下载与启动并行，
// 首个图标渲染时基本已就绪。
let spriteModule: Promise<typeof import('./sprite')> | null
  = typeof document === 'undefined' ? null : import('./sprite')

export function loadSprite() {
  return (spriteModule ??= import('./sprite'))
}
